import { useRecoilState } from 'recoil';
import { atom } from 'recoil';
import { localStorageEffect } from '@/utils/recoil';
import storage from '@/utils/storage1';

export const hiFreeModalState = atom({
  key: 'hideHiFreeModal',
  default: storage.hide_hi_free_modal,
  effects_UNSTABLE: [localStorageEffect('hide_hi_free_modal')],
});

export const useHiFreeModal = () => {
  const [hideHiFreeModal, setHideHiFreeModal] = useRecoilState(hiFreeModalState);

  return {
    hideHiFreeModal,
    setHideHiFreeModal,
  };
};
